import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// --- Global Initialization ---
import './index.css'; // Tailwind and global aesthetic resets
import './i18n';      // i18next localization engine

/**
 * 🚀 PERFORMANCE & ERROR TELEMETRY
 * Conditional import to prevent build errors (TS2307) if LogRocket 
 * is not present in the local environment.
 */
const initTelemetry = async () => {
  if (import.meta.env.PROD) {
    try {
      const LogRocket = (await import('logrocket')).default;
      const setupLogRocketReact = (await import('logrocket-react')).default;
      
      LogRocket.init('your-app-id/everyday-os'); 
      setupLogRocketReact(LogRocket);
      console.log('📡 Telemetry Uplink Active');
    } catch (e) {
      console.warn('⚠️ Telemetry failed to initialize. Continuing in offline mode.');
    }
  }
};

initTelemetry();

/**
 * 🌳 THE ROOT MOUNT
 * We wrap the App in BrowserRouter here so that the entire 
 * OS can leverage the navigation engine and URL-based routing.
 */
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error("Target container 'root' not found. Ensure index.html is correctly configured.");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* Note: AuthProvider and ThemeProvider are wrapped inside 
        the App component to handle internal context dependencies.
      */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);